module.exports = __webpack_public_path__ + "static/media/care.e55924ff.jpg";